module.exports = __webpack_public_path__ + "media/images/icons/flat-color-square-website-17a84f8ebcd235fe4990dc3fa25916ed.png";